import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/rise-up-king/left-cirle-rise.webp";
import BgImg1 from "../../../images/case-studies/rise-up-king/right-circle-rise.webp";

function Behindthesceneanimal() {
  return (
    <section className="behind-the-scene-animal p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#202020" }}>
              Building the Platform: TekRevol’s{" "}
              <span className="text-rise-yellow">Strategic Approach</span> from
              Concept to Creation
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="">
            <div className="behind-main">
              <div className="behind-flex">
                <div className="behind-box left-box">
                  <h5>Discovery & Research</h5>
                  <p>
                    Thoroughly understanding the needs of users and the client’s
                    vision for an all-encompassing platform that combines
                    personal development and community interaction.
                  </p>
                </div>
                <div
                  className="num left-padd"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  01
                </div>
              </div>
            </div>
            <div className="behind-main">
              <div className="behind-flex">
                <div className="behind-box left-box">
                  <h5>Technology & Feature Integration</h5>
                  <p>
                    Gamified elements like rankings and badges were integrated
                    to drive engagement, while a fully functional chat module
                    enabled smooth communication between users.
                  </p>
                </div>
                <div
                  className="num left-padd"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  03
                </div>
              </div>
            </div>

            <div className="behind-main">
              <div className="behind-flex">
                <div className="behind-box left-box">
                  <h5>Post-Deployment Support</h5>
                  <p>
                    Continuous updates and improvements based on user feedback,
                    ensuring the platform evolves with the community's needs.
                  </p>
                </div>
                <div
                  className="num left-padd"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  05
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={2}
            lg={2}
            xl={2}
            xxl={2}
            className="text-center column-none"
          >
            <StaticImage
              src="../../../images/case-studies/rise-up-king/line-rise.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={17}
              height={1435}
            />
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="">
            <div className="behind-main">
              <div className="behind-flex">
                <div
                  className="num right-padd"
                  style={{
                    backgroundImage: `url(${BgImg1})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  02
                </div>
                <div className="behind-box right-box">
                  <h5>Design & Development</h5>
                  <p>
                    We focused on creating a clean, intuitive UI for a seamless
                    user experience, paired with a robust backend to support
                    real-time data updates as the user base grew.
                  </p>
                </div>
              </div>
            </div>

            <div className="behind-main">
              <div className="behind-flex">
                <div
                  className="num right-padd"
                  style={{
                    backgroundImage: `url(${BgImg1})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  04
                </div>
                <div className="behind-box right-box">
                  <h5>Deployment & Testing</h5>
                  <p>
                    Phased rollout to ensure smooth functionality, user
                    experience testing, and bug fixes
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Behindthesceneanimal;
